import script from "./Installmian.vue?vue&type=script&setup=true&lang=js"
export * from "./Installmian.vue?vue&type=script&setup=true&lang=js"

import "./Installmian.vue?vue&type=style&index=0&id=0c84aec8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c84aec8"]])

export default __exports__